import React from 'react';
export function Guarantee() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(253,244,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(243,232,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-166">
      <div className="mx-auto max-w-3xl" data-id="element-167">
        <div className="rounded-2xl overflow-hidden shadow-sm" style={{
        border: '1px solid rgba(168,85,247,0.25)'
      }} data-id="element-168">

          {/* ── HEADER ── */}
          <div className="px-6 py-5 text-center" style={{
          background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)'
        }} data-id="element-169">
            <div className="text-5xl mb-3" data-id="element-170">🛡️</div>
            <h2 className="text-xl sm:text-2xl font-black text-white m-0" data-id="element-171">
              GARANTÍA MEGAPACK™ — 7 DÍAS
            </h2>
          </div>

          {/* ── BODY ── */}
          <div className="px-6 py-6 text-center" style={{
          backgroundColor: 'rgba(124,58,237,0.04)'
        }} data-id="element-172">
            <p className="text-sm text-gray-600 m-0 mb-2" data-id="element-173">
              Abrís los 6 tomos. Revisás los 6 bonos. Los usás con tu hijo si querés.
            </p>
            <p className="text-sm text-gray-600 m-0 mb-5" data-id="element-174">
              Si en 7 días no es lo que esperabas:
            </p>
            <p className="text-3xl font-black m-0 mb-3" style={{
            background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }} data-id="element-175">
              Te devolvemos el 100%.
            </p>
            <p className="text-base font-black text-gray-900 m-0" data-id="element-176">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
          </div>

          {/* ── FOOTER ── */}
          <div className="px-6 py-4 text-center" style={{
          backgroundColor: 'rgb(255,255,255)',
          borderTop: '1px solid rgba(168,85,247,0.15)'
        }} data-id="element-177">
            <p className="text-xs text-gray-500 m-0 leading-5" data-id="element-178">
              La confianza que tenemos en el Megapack Estimulación Temprana nos
              permite hacer esa promesa sin dudar.
              <br data-id="element-179" />
              Más de 2.400 madres de todo el país ya lo saben.
              <br data-id="element-180" />
              La tasa de devoluciones es menor al 1%.
            </p>
          </div>

        </div>
      </div>
    </section>;
}